
import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import EditUserForm from "./components/EditUserForm";

const EditUserPage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  
  if (!userId) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <h1 className="text-2xl font-semibold">Error: No User ID Provided</h1>
        <Button asChild className="mt-4">
          <Link to="/users">Return to Users List</Link>
        </Button>
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <Button variant="ghost" size="sm" asChild>
            <Link to={`/users/${userId}`}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to User Details
            </Link>
          </Button>
          <h1 className="text-3xl font-bold tracking-tight">Edit User</h1>
          <p className="text-muted-foreground">
            Update user details and permissions
          </p>
        </div>
      </div>
      
      <EditUserForm userId={userId} />
    </div>
  );
};

export default EditUserPage;
